<template>
  <div>
    <breadcrumb :crumbs="crumbs"></breadcrumb>
    <form class="ls-form" @submit.prevent="validateBeforeSubmit">
      <div class="row">
        <div class="col-md-4">
          <h3 class="ls-title-4">{{ $t('taxes.new.name_and_scope') }}</h3>
          <p>{{ $t('taxes.new.name_and_scope_information') }}</p>
        </div>
        <div class="col-md-8">

          <div class="row">
            <label class="ls-label col-md-6" :class="{'ls-error': errors.has($t('taxes.attributes.name')) }">
              <span class="ls-label-text">{{ $t('taxes.attributes.name') }}</span>
              <input
                name="taxes.name"
                type="text"
                v-model="tax.name"
                v-validate="'required'"
                :placeholder="$t('taxes.new.placeholder.name')"
                :name="$t('taxes.attributes.name')">
              <small class="ls-help-message" v-show="errors.has($t('taxes.attributes.name'))">{{ errors.first($t('taxes.attributes.name')) }}</small>
            </label>
          </div>

          <div class="row">
            <label class="ls-label col-md-6" :class="{'ls-error': errors.has($t('taxes.attributes.scope')) }">
              <span class="ls-label-text">{{ $t('taxes.attributes.scope') }}</span>
              <input
                name="tax.scope"
                type="text"
                maxlength="50"
                v-model="tax.scope"
                v-validate="'required'"
                :placeholder="$t('taxes.new.placeholder.scope')"
                :name="$t('taxes.attributes.scope')">
              <small class="ls-help-message" v-show="errors.has($t('taxes.attributes.scope'))">{{ errors.first($t('taxes.attributes.scope')) }}</small>
              <char-counter v-show="!errors.has($t('taxes.attributes.scope'))" v-model="tax.scope" :max="50"></char-counter>
            </label>
          </div>
        </div>
      </div>

      <div class="ls-clearfix ls-md-margin-bottom"></div>

      <div class="row">
        <div class="col-md-4">
          <h3 class="ls-title-4">{{ $t('taxes.new.value') }}</h3>
          <p>{{ $t('taxes.new.value_information') }}</p>
        </div>

        <div class="col-md-8">
          <div class="row">
            <label class="ls-label col-md-12" :class="{'ls-error': errors.has($t('taxes.attributes.value')) }">
             <span class="ls-label-text">{{ $t('taxes.attributes.value') }}
                <popover :position="'right'">
                  <div slot="content">{{ $t('taxes.new.popover.value') }}</div>
                </popover>
              </span>
              <div class="col-md-2 ls-no-padding">
                <input
                  type="number"
                  min="0"
                  step="0.01"
                  name="tax.value"
                  v-model="tax.value"
                  v-validate="'required|percentage'"
                  :name="$t('taxes.attributes.value')">
              </div>
              <small class="ls-help-message" v-show="errors.has($t('taxes.attributes.value'))">{{ errors.first($t('taxes.attributes.value')) }}</small>
            </label>
          </div>
        </div>

        <div class="ls-clearfix"></div>
        <div class="row">
          <div class="col-md-12">
            <div class="ls-actions-btn">
              <div class="ls-float-right">
                <button class="ls-btn" @click.prevent="pushBack()">{{ $t('application.button.cancel') }}</button>
                <button type="submit" class="ls-btn-primary">{{ $t('taxes.buttons.edit_tax') }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>

    </form>
  </div>
</template>
<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
  import Popover from 'src/app/components/shareds/popover/Popover'
  import CharCounter from 'src/app/components/shareds/char-counter/CharCounter'

  export default {
    name: 'EditPlan',
    components: { Breadcrumb, Popover, CharCounter },
    data () {
      return {
        crumbs: {
          'ico': 'ls-ico-edit-admin',
          'section': this.$t('taxes.edit.title'),
          'paths': {
            0: {
              'title': this.$t('taxes.main.title'),
              'path': '/taxes'
            },
            1: {
              'title': this.$t('taxes.edit.title'),
              'path': ''
            }
          }
        }
      }
    },
    mounted () {
      this.getTax()
    },
    computed: {
      ...mapGetters(['tax'])
    },
    methods: {
      ...mapMutations(['setTax']),
      ...mapActions(['loadTax', 'editTax']),
      getTax (params) {
        this.loadTax(this.$route.params.id)
      },
      validateBeforeSubmit () {
        this.$loader.show()
        this.$validator.validateAll().then(success => {
          if (!success) {
            this.$loader.hide()
            return
          }
          this.updateTax()
        })
      },
      updateTax () {
        this.editTax(this.tax).then((response) => {
          this.pushBack()
        })
      },
      pushBack () {
        this.$router.push({ name: 'tax_details', params: { id: this.tax.id } })
      }
    }
  }
</script>
<style lang="scss">
  .txt-check {
    margin: 0 0 0 6px;
    display: inline-block;
  }
  .select-plan {
    margin-top: 3px;
  }
  .ls-label .ls-label-text + p {
    font-size: 13px;
  }
  .ls-label .ls-label-text {
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// Edit.vue?1eb57846